<template>
  <div class="section fp-auto-height-responsive" id="recommend-section">
    <v-container>
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <v-row>
            <v-col cols="12" sm="6" class="d-sm-flex align-sm-center order-1 order-sm-0">
              <div class="section-contents text-center text-sm-left" ref="title">
                <h6>PASS 통합형 구독 서비스</h6>
                <h1>간편하고 편리한 PASS<br /><b>구독도 심플하고 편리하게!</b></h1>
                <p>금융기관의 휴대폰 인증 성공 / 실패 이력 정보 제공하며, <br class="br" />신용점수, 대출, 카드,연체, 보증 등 신용 정보 관리할 수 있습니다.<br class="br" />주식 투자 콘텐츠와 카드 이용 내역 / 계좌 관리까지<br class="br" />한번에 편리하게 이용할 수 있습니다.</p>
                <div class="btn"></div>
               <div class="btn" @click.stop="moveService" :data-ga-category="gaEvent.category.home.name" :data-ga-label="gaEvent.category.home.label1" :data-ga-action="gaEvent.actions.buttonClick">더보기<img src="@/assets/new/image/main/arrow_right.svg" alt="PASS 금융 상품 추천 더보기" /></div>
              </div>
            </v-col>
            <v-col cols="12" sm="6" class="text-center order-0 order-sm-1">
              <img ref="img" class="service-visual2" src="@/assets/new/image/main/home_passprime.svg" alt="PASS 통합형 구독 서비스" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { gsap } from "gsap";
import {GaTracking} from "@/mixins/index.js";
const { mapGetters } = createNamespacedHelpers("ui");

export default {
  mixins: [GaTracking],
  name: "PassPrime",
  components: {},
  computed: {
    ...mapGetters(["sectionNumber"])
  },
  watch: {
    sectionNumber() {
      const { title, img } = this.$refs;

      if (this.sectionNumber === 2) {
        gsap.to(title, .5, { opacity: 1, y: 0 })
        gsap.to(img, .5, { delay: .3, opacity: 1, y: 0 });
      }
    }
  },
  methods:{
    moveService(e){
      this.gaTracking(e);
      this.$router.push({name: 'PassPrime'});
    }
  }
};
</script>
